// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ShowImage--next-sr-only--1H4XJTn","button":"ShowImage--button--187CytR"};